import { render } from "./sales-receipt-cash.vue?vue&type=template&id=95344732&scoped=true"
import script from "./sales-receipt-cash.vue?vue&type=script&lang=js"
export * from "./sales-receipt-cash.vue?vue&type=script&lang=js"

import "./sales-receipt-cash.vue?vue&type=style&index=0&id=95344732&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95344732"]])

export default __exports__